import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Grid, List, ListItem, ListItemText, Typography, Divider } from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import { makeStyles } from '@material-ui/core/styles'
import _ from 'lodash'
import { formatArchiveForms } from 'api/fieldNotebooks'
import { useFormData } from 'components/contexts/FormDataProvider'
import FormStepper from './FormStepper'
import styles from './styles'
import './styles.css'

const useStyles = makeStyles(styles)

const FieldNotebooksForm = (data) => {

  const { t } = useTranslation();

  const [formSelected, setFormSelected] = useState()  
  const classes = useStyles()

  const handleForm = (form) => {
    setFormSelected(form)
    data.setIsFormSelected(true)   
  }
  
  const handleClick = () => {
    setFormSelected(undefined)
    data.setIsFormSelected(false)
  }

  if (_.isEmpty(data.archive)) {
    return <>{t('no_show_archive')}</>
  }

  
  const forms = formatArchiveForms(data.archive)
  const isSelected = !_.isUndefined(formSelected)

  return (
    <>
      {
        isSelected
          ?
          <Grid container className={classes.page__form}>
            <Grid item sm={12} xs={12}>
              <Typography variant='caption'>
                {t('operation_to_register')}
              </Typography>
            </Grid>
            <Grid item sm={12} xs={12} className={classes.page__title}>
              <Button
                variant='outlined'
                color='primary'
                onClick={() => handleClick()}
              >
                <ArrowBackIcon color='primary' className='left_arrow' />
                {t('back')}
              </Button>
            </Grid>
            <FormStepper form={formSelected} />
          </Grid>
          :
          <List className={classes.List}>
            {forms.map(form => (
              <Grid item sm={12} xs={12} key={form.form_id}>
                <ListItem 
                  alignItems='flex-start' 
                  button onClick={() => handleForm(form)}
                  className={classes.List__root_item}
                >
                  <ListItemText
                    primary={form.title.toUpperCase()}
                    secondary={form.description}
                    primaryTypographyProps={{ color: 'primary' }}
                  />
                </ListItem>
              </Grid>
            ))}
          </List>
      }
    </>
  )
}

export default FieldNotebooksForm